/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {UserProvider} from 'src/app/providers/index';
import { User} from 'src/app/model';
import { SearchableItem } from 'src/app/model/interface/searchable.item';

@Component({
  selector: 'page-user-edit-email',
  templateUrl: './edit-email.component.html',
  styleUrls: ['./edit-email.component.scss']
})

export class EditEmailComponent implements OnInit, OnDestroy {
  @Input() userId: number;
  @Input('edit') editFlag = false;
  @Output() onCreate: EventEmitter<SearchableItem> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Input() user: User = new User;

  constructor(
    public userProvider: UserProvider,
  ) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {}

  onSubmit(): void {
    this.userProvider.saveUser(this.user).subscribe(data => {
      if(data.success){
        this.onCreate.emit(User.parse(data.result));
      }
    });
  }

  actionCancel(): void {
    this.onCancel.emit();
  }
}
